import store from "../../../../../store/store";
import { regionReducer } from "../../../reducers/region";
import { login } from "../../../reducers/login";
import { cartReducer } from "../../../reducers/cart";
import { onGetCtnFromUrl, onResetForm } from "../../../../Authorization/actions/authorization";
import { setHiddenFields } from "../../../actions/account";
import { SET_LOGIN_MODEL } from "../../../actions/actionTypes";
import searchSlice from "../../../reducers/search";
export var prepareLoginStore = function prepareLoginStore(loginModel) {
  store.addReducer(regionReducer);
  store.addReducer(login);
  store.addReducer(cartReducer);
  store.addReducer(searchSlice);
  store.dispatch({
    type: SET_LOGIN_MODEL,
    payload: loginModel
  });
  store.dispatch(onResetForm());
  store.dispatch(onGetCtnFromUrl);
  store.dispatch(setHiddenFields);
};

// !!! Не убирать дефолтный экспорт
export default prepareLoginStore;